interface FileName {
  name: string;
  extension: string;
}

/**
 * Splits file name into name and its extension
 * @param fullName complete file name
 */

export function getFileNameComponents(fullName: string, alternateName?: string): FileName {
  const parts = fullName.split('.');
  if (parts.length < 2) {
    if (alternateName) return { name: parts[0], extension: getFileNameComponents(alternateName).extension };
    return { name: parts[0], extension: '' };
  } else {
    return {
      name: parts.slice(0, parts.length - 1).join('.'),
      extension: parts[parts.length - 1],
    };
  }
}

export function getImageSizeFromUrl(url: string, signal?: AbortSignal): Promise<number> {
  return new Promise<number>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('HEAD', url);

    const onCancel = () => {
      xhr.abort();
      reject('Request cancelled.');
    };

    if (signal) {
      signal.addEventListener('abort', onCancel, { once: true });
    }

    xhr.addEventListener('error', reject);
    xhr.addEventListener('load', function (data) {
      resolve((data as any).total);
    });

    xhr.send();
  });
}

/**
 * Splits file name into name and its extension
 * @param originalFileName file name (with or without extension)
 * @param fileName file name (random characters) with extension
 */
export function splitFileNameAndExtension(originalFileName: string, fileName?: string) {
  let extension = '';

  if (fileName) extension = fileName.split('.').pop() ?? '';
  if (!extension) extension = originalFileName.split('.').pop() ?? '';

  const doesOriginalFileNameContainExtension = originalFileName.split('.').at(-1) === extension;
  if (!doesOriginalFileNameContainExtension) return { name: originalFileName, extension };

  const parts = originalFileName.split('.');
  const name = parts.slice(0, parts.length - 1).join('.');

  return { name, extension };
}
